import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'La collezione completa in 6 volumi + 5 bonus per insegnare in classe l’industria del petrolio e del gas in modo chiaro, visivo e pronto all’uso.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="sky-backdrop min-h-screen w-full overflow-hidden font-sans text-muted antialiased" data-id="element-0" data-mp="nvarfq9f9dfl">
      <MetaPixel data-id="element-1" data-mp="ssssyvl40qdk" />
      <main data-id="element-2" data-mp="swghthfm0oly">
        <Hero data-id="element-3" data-mp="3684vetzoctf" />
        <LookInsideCarousel data-id="element-4" data-mp="35oymvdpbcv8" />
        <ProblemSection data-id="element-5" data-mp="34x1hg4gh72u" />
        <SystemSection data-id="element-6" data-mp="38ktuby5znfz" />
        <ModulesSection data-id="element-7" data-mp="3ud1ftael3qb5" />
        <BonusSection data-id="element-8" data-mp="3ubrfsfo6881v" />
        <UrgencySection data-id="element-9" data-mp="3uc9i9u1ffii8" />
        <PricingSection data-id="element-10" data-mp="3uf5hrmsxaf8s" />
        <GuaranteeSection data-id="element-11" data-mp="d57gn6a1wokn" />
        <FAQ data-id="element-12" data-mp="d3mi75km8lhi" />
        <ClosingSection data-id="element-13" data-mp="d45ti3frgbmk" />
        <SummaryTable data-id="element-14" data-mp="d2bj3j2481wq" />
        <FinalCta data-id="element-15" data-mp="85ukfuxai55e" />
      </main>
      <Footer data-id="element-16" data-mp="86w6svjrae2f" />
      <PurchaseNotification data-id="element-17" data-mp="8649ngaig8a1" />
    </div>;
}